import React from "react";
import { NavLink } from "react-router-dom";

const Footer = () => {
    return (
        <div>
            <footer class="relative pt-8 pb-6 bg-gray-200">
                <div class="container mx-auto px-4">
                    <div class="flex flex-wrap text-left lg:text-left">
                        <div class="w-full lg:w-6/12 px-4">
                            <h3
                                className="text-3xl  font-myFont font-bold py-1"

                            >
                                Dafalapur Urban Bank
                            </h3>
                            <h4 class="text-3xl  text-black font-myFont py-1">
                                Let's keep in touch!
                            </h4>
                            <h5 class="text-lg mt-0 mb-2  font-myFont py-1">
                                Find us on any of these platforms, we respond
                                1-2 business days.
                            </h5>
                        </div>
                        <div class="w-full lg:w-6/12  px-4">
                            <div class="flex flex-wrap items-top mb-6">
                                <div class="w-1/2 lg:w-4/12 px-4 ml-auto">
                                    <span class="block text-black uppercase text-sm font-semibold pb-6">
                                        Services
                                    </span>
                                    <ul class="list-unstyled">
                                        <li>
                                            <NavLink
                                                to="/"
                                                className="  text-black hover:text-blue-600 font-semibold block pb-2 text-sm"
                                                href="#services"
                                            >
                                                RTGS/NEFT
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink
                                                to="/"
                                                className=" text-black hover:text-blue-600 font-semibold block pb-2 text-sm"
                                                href="#services"
                                            >
                                                Locker
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink
                                                to="/"
                                                className=" text-black hover:text-blue-600 font-semibold block pb-2 text-sm"
                                                href="#services"
                                            >
                                                SMS Banking
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink
                                                to="/"
                                                className=" text-black hover:text-blue-600 font-semibold block pb-2 text-sm"
                                                href="#services"
                                            >
                                                APBS
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink
                                                to="/"
                                                className=" text-black hover:text-blue-600 font-semibold block pb-2 text-sm"
                                                href="#services"
                                            >
                                                Any Branch Banking
                                            </NavLink>
                                        </li>
                                    </ul>
                                </div>
                                <div class="w-1/2 lg:w-4/12 px-4">
                                    <span class="block uppercase  text-black text-sm font-semibold pb-6">
                                        Quick Links
                                    </span>
                                    <ul class="list-unstyled">
                                        <li>
                                            <NavLink
                                                to="/"
                                                className=" text-black hover:text-blue-600 font-semibold block pb-2 text-sm"
                                                href="#quicklinks"
                                            >
                                                IFSC Code
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink
                                                to="/"
                                                className=" text-black hover:text-blue-600 font-semibold block pb-2 text-sm"
                                                href="#quicklinks"
                                            >
                                                Rate Of Interest
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink
                                                to="/"
                                                className=" text-black hover:text-blue-600 font-semibold block pb-2 text-sm"
                                                href="#quicklinks"
                                            >
                                                Bank Holidays
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink
                                                to="/"
                                                className="text-black hover:text-blue-600 font-semibold block pb-2 text-sm"
                                                href="#quicklinks"
                                            >
                                                KYC Norms
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink
                                                to="/"
                                                className="text-black hover:text-blue-600 font-semibold block pb-2 text-sm"
                                                href="#quicklinks"
                                            >
                                                Complaint Regarding to
                                                Transaction
                                            </NavLink>
                                        </li>
                                    </ul>
                                </div>
                                <div class="w-1/2 lg:w-4/12 px-4">
                                    <span class="block uppercase text-black text-sm font-semibold pb-6">
                                        Social Media
                                    </span>
                                    <ul class="list-unstyled">
                                        <li>
                                            <a
                                                class="text-black hover:text-blue-600 font-semibold block pb-2 text-sm"
                                                href="/"
                                                rel="noopener noreferrer"
                                                target="_blank"
                                            >
                                                <i className="fab fa-facebook-f"></i>{" "}
                                                Facebook
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                class="text-black hover:text-blue-600 font-semibold block pb-2 text-sm"
                                                href="/"
                                            >
                                                <i className="fab fa-twitter"></i>{" "}
                                                Twitter
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                class="text-black hover:text-blue-600 font-semibold block pb-2 text-sm"
                                                href="/"
                                            >
                                                <i className="fab fa-instagram"></i>{" "}
                                                Instagram
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                class="text-black hover:text-blue-600 font-semibold block pb-2 text-sm"
                                                href="/"
                                                rel="noopener noreferrer"
                                                target="_blank"
                                            >
                                                <i className="fab fa-youtube"></i>{" "}
                                                YouTube
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr className="bg-gray-100" />
                    <div class="flex flex-wrap items-center md:justify-between justify-center">
                        <div class="w-full md:w-4/12 mx-auto text-center">
                            <div class="text-sm text-black hover:text-blue-400 font-semibold py-10 ">
                                © <span id="get-current-year">2021 </span>
                                Dafalapur Urban Co-op Bank Ltd. | Designed & developed
                                by{" "}
                                <a className="" href="http://5techg.com" target="_blank">
                                    5TechG Lab Lets Buid Together
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default Footer;
